export default {
  wallet: {
    title: 'Dompet',
    balance: 'Saldo',
    deposit: 'Deposit',
    withdraw: 'Tarik',
    rollover: 'Rollover',
    transaction: 'Transaksi',
    myBet: 'Taruhan Saya',
    totalBalance: 'Total Saldo',
    withdrawableBalance: 'Saldo Dapat Ditarik',
    bonus: 'Bonus',
    bonusBalance: 'Saldo Bonus',
    cashBalance: 'Saldo Tunai',
    withdrawable: 'Dapat Ditarik',
    depositNow: 'Deposit Sekarang',
    getBonus: 'Dapatkan Bonus',
    bonusGames: 'Game Bonus',
    playNow: 'Main Sekarang',
    fiatAccount: 'Akun Fiat',
    cash: 'Tunai',
    rules: 'Aturan',
    ruleQ1: '1. Apa itu Bonus?',
    ruleA1: 'Bonus adalah hadiah yang diberikan platform setelah mengikuti aktivitas dan dapat digunakan untuk bertaruh di game bonus yang ditentukan.',
    ruleQ2: '2. Bagaimana cara menggunakan bonus?',
    ruleA2: 'Bonus hanya dapat digunakan untuk bertaruh setelah saldo dompet tunai habis. Bonus harus memenuhi syarat taruhan sebelum dapat dikonversi ke dompet tunai.',
    ruleQ3: '3. Game apa saja yang mendukung taruhan bonus?',
    ruleA3: 'Sebagian besar game slot mendukung taruhan bonus. Untuk daftar game lengkap, silakan lihat halaman Game Bonus.',
    ruleQ4: '4. Apakah ada batasan untuk mengonversi bonus ke dompet tunai?',
    ruleA4: 'Setelah syarat taruhan bonus terpenuhi, Anda dapat mengonversi bonus asli ke dompet tunai di Pusat Hadiah. Sisa keuntungan bonus akan dikembalikan ke Dompet Bonus, dan syarat taruhan akan dihitung ulang.',
    ruleQ5: '5. Apakah ada batasan untuk mengonversi keuntungan bonus ke dompet tunai?',
    ruleA5: 'Keuntungan bonus harus memenuhi syarat taruhan 15x. Keuntungan bonus maksimum yang dapat dikonversi ke dompet tunai adalah USDT5.000,00, dan jumlah maksimum per taruhan adalah USDT1.000,00.',
    ruleQ6: '6. Bagaimana syarat taruhan dihitung?',
    ruleA6: 'Game slot: Jumlah taruhan = Syarat taruhan. Game lain: Jumlah taruhan = Nilai absolut keuntungan (hingga jumlah taruhan)',
    select: 'Pilih',
    currency: 'Mata Uang',
    loading: 'Memuat...',
    noMoreData: 'Tidak ada data lagi',
    noData: 'Tidak ada data',
    colType: 'Jenis',
    colTime: 'Waktu',
    colStatus: 'Status',
    colAmount: 'Jumlah',
    colBalance: 'Saldo',
    allType: 'Semua Jenis',
    allStats: 'Semua Status',
    colWallet: 'Dompet',
    colCurrent: 'Saat Ini',
    colRequired: 'Diperlukan',
    colStats: 'Status',
    totalVaultBalance: 'Total Saldo Brankas',
    amount: 'Jumlah',
    availableBalance: 'Saldo Tersedia:',
    max: 'MAKS',
    depositInVault: 'Deposit ke Brankas',
    depositCurrency: 'Mata Uang Deposit',
    currencyBalance: 'Saldo Mata Uang',
    history: 'Riwayat',
    vaultRules: 'Aturan Brankas',
    vaultRule1: 'Brankas adalah tempat aman untuk menyimpan dana tanpa khawatir biaya transaksi atau keterlambatan blockchain. Brankas berfungsi seperti dompet digital Anda sendiri atau bahkan seperti rekening tabungan bank. Sangat aman – berkat 2FA – dan Anda dapat menerapkan langkah keamanan tambahan untuk menjaga dana di dalamnya.',
    vaultRule2: 'Deposit dan penarikan dana di Brankas dilindungi oleh 2FA dan dapat diakses oleh pemilik dana kapan saja.',
    vaultRule3: 'Dana di Brankas tidak akan disentuh siapa pun kecuali pemiliknya. Ini milik Anda, dan akan selalu aman untuk Anda gunakan!',
    selectTime: 'Pilih Waktu',
    colGame: 'Game',
    colBet: 'Taruhan',
    colWin: 'Menang',
    colProfit: 'Keuntungan',
    sports: 'Olahraga',
    allGames: 'Semua game',
    today: 'Hari Ini',
    yesterday: 'Kemarin',
    last3Days: '3 hari terakhir',
    last7Days: '7 hari terakhir',
    last15Days: '15 hari terakhir',
    last30Days: '30 hari terakhir',
  },
};
